﻿/*  --------------------------------------
  assets/z_cart-main-wccg.js
  Version  1.0.0 Build 001  (24-05-2026)
  Lines: 358
  --------------------------------------------------------
*/

(function() {
  'use strict';

  var W = window.WCCG_CART || {};
  var name = W.name || 'z_cart-main-wccg';
  var moneyFmt = W.moneyFormat || '${{amount}}';
  var savingsEnabled = W.savingsEnabled !== false;

  function log(msg, data) {
    if (data !== undefined) console.log('[' + name + '] ' + msg, data);
    else console.log('[' + name + '] ' + msg);
  }

  /* ── Money formatter (Shopify-style) ── */
  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = moneyFmt;

    function defaultOption(opt, def) { return (opt === undefined ? def : opt); }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cents = parts[1] ? decimal + parts[1] : '';
      return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':                 value = formatWithDelimiters(cents, 2); break;
      case 'amount_no_decimals':     value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator':           value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_space_separator':           value = formatWithDelimiters(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = formatWithDelimiters(cents, 0, ' '); break;
      default:                       value = formatWithDelimiters(cents, 2);
    }
    return formatString.replace(placeholderRegex, value);
  }

  /* ── Cart-API kald ── */
  function changeItem(key, qty) {
    log('Change ' + key + ' → qty ' + qty);
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        log('Cart updated — items: ' + cart.item_count + ', total: ' + cart.total_price);
        return cart;
      })
      .catch(function(err) {
        console.error('[' + name + '] Change error:', err);
      });
  }

  /* ── Re-render hele cart-siden via Shopify Section Rendering API ── */
  function refreshCartSection() {
    var section = document.querySelector('[data-wccg-cart]');
    if (!section) return Promise.resolve();

    /* Section_id på cart-template er typisk "main" — men brug Shopify-API'en */
    return fetch('/cart?sections=main', { credentials: 'same-origin' })
      .then(function(r) {
        if (!r.ok) throw new Error('Section fetch failed: ' + r.status);
        return r.json();
      })
      .then(function(data) {
        var html = data.main;
        if (!html) {
          log('Section reload returnerede ikke HTML — falder tilbage til full reload');
          window.location.reload();
          return;
        }
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newCart = doc.querySelector('[data-wccg-cart]');
        if (newCart && section.parentNode) {
          section.parentNode.replaceChild(newCart, section);
          /* Re-bind events på den nye DOM */
          var freshRoot = document.querySelector('[data-wccg-cart]');
          if (freshRoot) freshRoot.dataset.wccgBound = '';
          bindEvents();
          /* Re-trigger related products filter (kører selv-bindEvents fra related-modul) */
          if (window.WCCG_CART_related_refresh) window.WCCG_CART_related_refresh();
          log('Cart-sektion re-rendret OK');
        } else {
          log('Kunne ikke finde ny [data-wccg-cart] i response — fallback reload');
          window.location.reload();
        }
      })
      .catch(function(err) {
        console.error('[' + name + '] Section refresh fejlede:', err);
        window.location.reload();
      });
  }

  /* ── Inline opdatering (uden full re-render) ── */
  function updateInline(cart) {
    /* Subtotal */
    var subtotalEl = document.querySelector('[data-wccg-subtotal]');
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

    /* Total besparelse */
    var savingsEl = document.querySelector('[data-wccg-total-savings]');
    if (savingsEl) {
      if (cart.total_discounts > 0) {
        savingsEl.textContent = formatMoney(cart.total_discounts);
        var row = savingsEl.closest('.wccg-cart__savings-row');
        if (row) row.style.display = 'flex';
      } else {
        var row2 = savingsEl.closest('.wccg-cart__savings-row');
        if (row2) row2.style.display = 'none';
      }
    }

    /* Pr. linje qty + price */
    cart.items.forEach(function(item) {
      var row = document.querySelector('[data-wccg-item][data-key="' + item.key + '"]');
      if (!row) return;
      var qtyEl = row.querySelector('[data-wccg-qty]');
      if (qtyEl) qtyEl.textContent = item.quantity;
      /* Opdater pr.-linje pris via dedikeret selector (uafhængig af layout) */
      var saleEl = row.querySelector('[data-wccg-line-sale]');
      if (saleEl) saleEl.textContent = formatMoney(item.line_price);
    });

    /* Opdater Normal pris-linje hvis den findes */
    var normalEl = document.querySelector('[data-wccg-normal-total]');
    if (normalEl) {
      var normalTotal = 0;
      cart.items.forEach(function(it) {
        var comp = it.compare_at_price; /* Shopify Ajax API: compare_at_price ligger på line item */
        if (comp && comp > it.price) {
          normalTotal += comp * it.quantity;
        } else {
          normalTotal += it.original_line_price;
        }
      });
      normalEl.textContent = formatMoney(normalTotal);
    }

    /* Hvis tom kurv: vis "Kurven er tom" inline */
    if (cart.item_count === 0) {
      var root = document.querySelector('[data-wccg-cart]');
      if (root) {
        var continueUrl = '/collections/all';
        root.innerHTML =
          '<h1 class="wccg-cart__title">Indk\u00f8bskurv</h1>' +
          '<div class="wccg-cart__empty">' +
            '<p>Din kurv er tom.</p>' +
            '<a href="' + continueUrl + '">Forts\u00e6t med at shoppe</a>' +
          '</div>';
      }
    }
  }

  /* ── Event delegation ── */
  function bindEvents() {
    var root = document.querySelector('[data-wccg-cart]');
    if (!root || root.dataset.wccgBound === '1') return;
    root.dataset.wccgBound = '1';

    root.addEventListener('click', function(e) {
      var btn;

      btn = e.target.closest('[data-wccg-plus]');
      if (btn) {
        e.preventDefault();
        var row = btn.closest('[data-wccg-item]');
        var key = row.dataset.key;
        var current = parseInt(row.querySelector('[data-wccg-qty]').textContent) || 1;
        /* Optimistisk UI: vis loading-state, så re-render hele sektionen */
        row.style.opacity = '0.6';
        changeItem(key, current + 1).then(function(cart) {
          if (cart) refreshAfterGiftSettle(cart);
        });
        return;
      }

      btn = e.target.closest('[data-wccg-minus]');
      if (btn) {
        e.preventDefault();
        var row2 = btn.closest('[data-wccg-item]');
        var key2 = row2.dataset.key;
        var current2 = parseInt(row2.querySelector('[data-wccg-qty]').textContent) || 1;
        row2.style.opacity = '0.6';
        var newQty = current2 <= 1 ? 0 : current2 - 1;
        changeItem(key2, newQty).then(function(cart) {
          if (cart) refreshAfterGiftSettle(cart);
        });
        return;
      }

      btn = e.target.closest('[data-wccg-remove]');
      if (btn) {
        e.preventDefault();
        var row3 = btn.closest('[data-wccg-item]');
        var key3 = row3.dataset.key;
        row3.style.opacity = '0.5';
        changeItem(key3, 0).then(function(cart) {
          if (cart) refreshAfterGiftSettle(cart);
        });
        return;
      }
    });
  }

  /* ──────────────────────────────────────────────────────────────
     GIFT-AWARE REFRESH (poll-til-stable, refresh-once)
     ────────────────────────────────────────────────────────────────
     Gift-apps (AppHero, BOGO etc.) tilføjer gaver ASYNC efter
     /cart/change.js. Tidligere lavede vi refresh umiddelbart +
     poll bagefter → "hængte en bag ud" når gaven kom mellem
     refresh og næste klik.

     Ny strategi:
       1. updateInline(cart) — instant qty/subtotal feedback
       2. Poll /cart.js indtil item_count er STABIL i 2 successive
          polls (eller maxAttempts hits)
       3. Refresh sektionen ÉN gang med endelig state

     Resultat: alt er konsistent ved første visuelle opdatering,
     også hvis gaven kommer 800ms efter qty-change.
     ────────────────────────────────────────────────────────────── */
  function refreshAfterGiftSettle(initialCart) {
    /* Step 1: Instant inline-feedback (qty, subtotal, normal-pris) */
    if (initialCart) {
      try { updateInline(initialCart); } catch (e) { /* non-fatal */ }
    }

    var prevCount = initialCart ? initialCart.item_count : -1;
    var stableCount = prevCount;
    var stableHits = 0;
    var attempts = 0;
    var maxAttempts = 6;       /* 6 × 300ms = 1.8s max */
    var pollInterval = 300;
    var firstDelay = 250;      /* Giv gift-app et hovedstart */

    function finalize(reason, finalCount) {
      if (finalCount !== prevCount) {
        log('Gift settled (count ' + prevCount + ' → ' + finalCount + ') — ' + reason);
      } else {
        log('Cart stable — ' + reason);
      }
      refreshCartSection();
    }

    function poll() {
      attempts++;
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          if (cart.item_count === stableCount) {
            stableHits++;
            if (stableHits >= 2 || attempts >= maxAttempts) {
              finalize(stableHits >= 2 ? 'stable' : 'max attempts', cart.item_count);
            } else {
              setTimeout(poll, pollInterval);
            }
          } else {
            /* Count ændrede sig — gift kom (eller anden async), reset stable-tæller */
            log('Count ændret (' + stableCount + ' → ' + cart.item_count + '), venter på stabilisering');
            stableCount = cart.item_count;
            stableHits = 1;
            if (attempts >= maxAttempts) {
              finalize('max attempts after change', cart.item_count);
            } else {
              setTimeout(poll, pollInterval);
            }
          }
        })
        .catch(function() { refreshCartSection(); });
    }

    setTimeout(poll, firstDelay);
  }

  /* ── Countdown timer — KUN VISUEL, ingen cart-lock, genstarter ved 0 ── */
  function startCountdown() {
    var el = document.querySelector('[data-wccg-countdown]');
    if (!el) return;
    var display = el.querySelector('[data-wccg-countdown-display]');
    var textEl = el.querySelector('[data-wccg-countdown-text]');
    var minutes = parseInt(el.dataset.minutes) || 5;

    /* JS-FALLBACK: replace {minutes} client-side hvis Liquid-replace fejlede */
    if (textEl) {
      var html = textEl.innerHTML;
      var replaced = html
        .replace(/\{\{\s*minutes\s*\}\}/g, String(minutes))
        .replace(/\{\s*minutes\s*\}/g, String(minutes))
        .replace(/%minutes%/g, String(minutes))
        .replace(/&#123;\s*minutes\s*&#125;/g, String(minutes))
        .replace(/&lcub;\s*minutes\s*&rcub;/g, String(minutes));
      if (replaced !== html) {
        textEl.innerHTML = replaced;
        log('Countdown: {minutes} placeholder replaced client-side');
      }
    }

    /* sessionStorage så timeren overlever side-navigation */
    var key = 'wccg_cart_countdown_end';
    var endTime = parseInt(sessionStorage.getItem(key));
    var now = Date.now();
    if (!endTime || endTime < now) {
      endTime = now + minutes * 60 * 1000;
      sessionStorage.setItem(key, endTime);
    }

    function tick() {
      var remaining = Math.max(0, endTime - Date.now());
      var mm = Math.floor(remaining / 60000);
      var ss = Math.floor((remaining % 60000) / 1000);
      if (display) {
        display.textContent = (mm < 10 ? '0' : '') + mm + ':' + (ss < 10 ? '0' : '') + ss;
      }
      if (remaining === 0) {
        /* GENSTART timer — ingen lock, ingen "Udløbet" tekst */
        endTime = Date.now() + minutes * 60 * 1000;
        sessionStorage.setItem(key, endTime);
        log('Countdown: udløbet, genstarter automatisk');
      }
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ── Init ── */
  function init() {
    if (!document.querySelector('[data-wccg-cart]')) return;
    bindEvents();
    startCountdown();
    log('module loaded — savingsEnabled: ' + savingsEnabled);
  }

  /* ── Public API: brugt af z_cart-main-wccg-related.js ── */
  window.WCCG_CART_refresh = function() {
    return refreshCartSection().then(function() {
      log('Cart-section refreshed via WCCG_CART_refresh()');
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
